import type { SelectedMenus } from '@/types/menu.type';
import type { Organization } from '@/types/organization';

export interface SessionSettings {
  firstSelectedMenu: string;
  selectedMenus: SelectedMenus;
  selectedOrg: Organization | null;
  secondMenuTitle: Record<string, string>;
}

export const DEFAULT_SETTINGS: SessionSettings = {
  firstSelectedMenu: 'dashboard',
  selectedMenus: {},
  selectedOrg: null,
  secondMenuTitle: {},
};

const SESSION_SETTINGS_PREFIX = 'console_settings';

const getSessionSettingsKey = (userId?: string): string => {
  return userId
    ? `${SESSION_SETTINGS_PREFIX}_${userId}`
    : SESSION_SETTINGS_PREFIX;
};

export const saveSessionSettings = (
  settings: Partial<SessionSettings>,
  userId?: string
) => {
  try {
    const key = getSessionSettingsKey(userId);
    const currentSettings = loadSessionSettings(userId);
    const newSettings = { ...currentSettings, ...settings };
    sessionStorage.setItem(key, JSON.stringify(newSettings));
  } catch (error) {
    console.error('Failed to save settings:', error);
  }
};

export const loadSessionSettings = (userId?: string): SessionSettings => {
  try {
    const key = getSessionSettingsKey(userId);
    const settings = sessionStorage.getItem(key);
    if (settings) {
      return { ...DEFAULT_SETTINGS, ...JSON.parse(settings) };
    }
  } catch (error) {
    console.error('Failed to load settings:', error);
  }
  return DEFAULT_SETTINGS;
};
